// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3pymo","selected":"Chip_selected__3yQYh"};